import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { AdminUrlBuilder } from "../../../../../shared/admin/api/admin-url-builder";

@Component({
  templateUrl: './api-access-token.component.html',
  styleUrls: ['./api-access-token.component.scss'],
})
export class AdminApiAccessTokenComponent implements OnDestroy {

  isLoading: boolean = false;
  products: any[] = [];
  private modalEventsSubject: Subject<any>;
  isGenerateWarning: boolean = false;
  isRevokeWarning: boolean = false;
  _accessToken: string;
  isRevoking: boolean;
  isGenerating: boolean;
  private photographerId: number;

  get accessToken(): string {
    if (!this._accessToken) {
      return '';
    }
    if (this._accessToken.length <= 30) {
      return this._accessToken;
    } else {
      return this._accessToken.substring(0, 30) + '***';
    }
  }

  constructor(public modalRef: BsModalRef,
              private httpClient: HttpClient,
              private urlBuilder: AdminUrlBuilder,
              private toastrService: ToastrService) {
  }

  initialize(photographerId: number) {
    this.photographerId = photographerId;
    this.isLoading = true;
    this.httpClient.get(this.urlBuilder.buildUrl(`/ingest/token/${photographerId}`))
      .subscribe((response: any) => {
        this.isLoading = false;
        this._accessToken = response.accessToken;
      }, (error: any) => {
        this.toastrService.error('There was a problem with getting access token. Please contact administrator.')
        this.isLoading = false;
      });
  }

  revokeToken() {
    this.isRevoking = true;
    this.httpClient.delete(this.urlBuilder.buildUrl(`/ingest/token/${this.photographerId}`))
      .subscribe((response: any) => {
        this.isRevoking = false;
        this.isRevokeWarning = false;
        this._accessToken = null;
        this.toastrService.success('Access token revoked successfully');
      }, (error: any) => {
        this.toastrService.error('There was a problem with generating access token. Please contact administrator.')
        this.isRevoking = false;
        this.isRevokeWarning = false;
      });
  }

  ngOnDestroy() {
    if (this.modalEventsSubject) {
      this.modalEventsSubject.complete();
    }
  }

  close() {
    this.modalRef.hide();
  }

  closeRevokeWarning() {
    this.isRevokeWarning = false;
  }

  closeGenerateWarning() {
    this.isGenerateWarning = false;
  }

  confirmGenerate() {
    this.isGenerateWarning = true;
  }

  confirmRevoke() {
    this.isRevokeWarning = true;
  }

  generate() {
    this.isGenerating = true;
    this.httpClient.post(this.urlBuilder.buildUrl(`/ingest/token/${this.photographerId}`), {})
      .subscribe((response: any) => {
        this.isGenerating = false;
        this.isGenerateWarning = false;
        this._accessToken = response.accessToken;
        this.toastrService.success('Access token generated successfully');
      }, (error: any) => {
        this.toastrService.error('There was a problem with generating access token. Please contact administrator.')
        this.isGenerating = false;
        this.isGenerateWarning = false;
      });
  }

  copyTokenToClipboard() {
    navigator.clipboard.writeText(this._accessToken).then(() => {
      this.toastrService.success('Copied');
    }).catch(err => {
      this.toastrService.error('Error');
    });
  }
}
